import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  successMock,
  tutorCourseListGetMock,
  updateCourseDetailsGetMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { coursePath } from '../../utils/paths';

export default {
  tutorCourseListGet: (filters) => {
    if (shouldUseMock()) {
      return tutorCourseListGetMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}editable/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  updateCourseDetailsGet: (id) => {
    if (shouldUseMock()) {
      return updateCourseDetailsGetMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/update`, 'GET');
  },
  tutorCourseDelete: (id) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${coursePath}course/${id}/delete`, 'POST');
  },
};
